<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'disciplinas' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Componente Curricular
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider name="Código" rules="required" v-slot="{ errors }">
              <e-label>Código</e-label>
              <v-text-field
                v-model="form.codigo"
                maxlength="10"
                counter="10"
                solo
                dense
                :error-messages="errors.length ? errors : apiErrors.codigo"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="8">
            <ValidationProvider name="Descrição" rules="required" v-slot="{ errors }">
              <e-label>Descrição</e-label>
              <v-text-field
                v-model="form.descricao"
                dense
                solo
                :error-messages="apiErrors.descricao || errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="8">
            <ValidationProvider name="Area de conhecimento" v-slot="{ errors }">
              <e-label>Area de conhecimento</e-label>
              <v-select
                v-model="form.area_conhecimento"
                :items="areasConhecimentoList"
                label="Selecione uma área de conhecimento"
                item-text="descricao"
                item-value="id"
                dense
                solo
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              block
              >Enviar Dados</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("Disciplinas", ["disciplinasList", "carregandoDisciplinas"]),
    ...mapGetters("Disciplinas", ["disciplinas"]),
    form() {
      if (!this.disciplinas || !this.editing) return {};
      const { disciplina_id } = this.$route.params;
      const disciplina = this.disciplinas.get(parseInt(disciplina_id, 10));
      return {
        ...disciplina,
      };
    },
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      submittingForm: false,
      areasConhecimentoList: [],
      apiErrors: [],
    };
  },
  methods: {
    ...mapActions("Disciplinas", ["loadDisciplinas"]),
    async submitForm() {
      this.submittingForm = true;

      Object.keys(this.apiErrors).forEach((key) => {
        this.apiErrors[key] = [];
      });

      try {
        if (this.editing) {
          await this.$services.disciplinasService.atualizarDisciplina(this.form);
        } else {
          await this.$services.disciplinasService.criarDisciplina(this.form);
        }
        this.$toast.success("Componente Curricular Atualizado com sucesso");
        this.$router.push({ name: "disciplinas" });
      } catch (error) {
        if (error?.errors) {
          Object.keys(error.errors).forEach((key) => {
            this.apiErrors[key] = Array.isArray(error.errors[key])
              ? error.errors[key]
              : [error.errors[key]];
          });
        } else {
          this.$handleError(error);
        }
      }
      this.submittingForm = false;
    },
    async loadData() {
      try {
        if (this.disciplinas.length === 0) {
          this.$loaderService.open("Carregando dados");
        }
        await this.loadAreasConhecimento();
        await Promise.all([this.loadDisciplinas()]);
        this.$loaderService.close();
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async loadAreasConhecimento() {
      try {
        const data = await this.$services.disciplinasService.listarAreasConhecimento();
        this.areasConhecimentoList = data;
      } catch (error) {
        this.$handleError(error);
      }
    },
  },
};
</script>

<style></style>
